/* eslint-disable react/prop-types */
import React from 'react';
import InstallationInfoCard from './InstallationInfoCard';
import InstallationPlatformSplit from './InstallationPlatformSplit';

/**
 * All-time installation KPI cards (feature 031, US1 / FR-003-004).
 * Range-INDEPENDENT — always describes the whole dataset.
 *
 * Two cards, not four: Total Installs carries Android and iOS on its own line rather
 * than as two cards of their own, because the two ARE the total split in half — side by
 * side as equals they invited adding up three headline figures that are not independent.
 *
 * What each card counts lives behind its `i` button (see InstallationInfoCard), so the
 * row is figures only. Every count uses tabular numerals; no colour-only meaning.
 *
 * Props: { allTime }  — { total_installs, android_installs, ios_installs,
 *                          installs_today, installs_7d, installs_30d }
 */
const n = (v) => (v === null || v === undefined ? '—' : Number(v).toLocaleString());

const InstallationKpiCards = ({ allTime = {} }) => (
  <div className="au-cards inst-cards" data-testid="inst-kpi-cards">
    <InstallationInfoCard
      id="all-time"
      title="Total Installs"
      note={(
        <>Every install row ever recorded, excluding TestFlight and internal “shell”
          builds. <b>Android</b> and <b>iOS</b> beside it split that same total by device
          platform, so the two add up to it. All-time — the date range does not apply.</>
      )}
    >
      <div className="inst-line">
        <span className="au-card__value inst-num">{n(allTime.total_installs)}</span>
        <InstallationPlatformSplit
          inline
          testId="inst-kpi-platform"
          items={[
            { label: 'Android', testId: 'inst-kpi-android', value: n(allTime.android_installs) },
            { label: 'iOS', testId: 'inst-kpi-ios', value: n(allTime.ios_installs) },
          ]}
        />
      </div>
    </InstallationInfoCard>

    <InstallationInfoCard
      id="recent"
      title="Today / 7d / 30d"
      note={(
        <>Installs in the last 1 / 7 / 30 <b>UTC calendar days</b> (today plus the prior
          6 / 29 days) — these reconcile with the per-day table below. Like Total
          Installs, they are fixed windows and ignore the date range.</>
      )}
    >
      <span className="au-card__value inst-num">
        {n(allTime.installs_today)} / {n(allTime.installs_7d)} / {n(allTime.installs_30d)}
      </span>
    </InstallationInfoCard>
  </div>
);

export default InstallationKpiCards;
